import { render, staticRenderFns } from "./SalesProgressCard.vue?vue&type=template&id=506d6d9c&scoped=true&"
import script from "./SalesProgressCard.vue?vue&type=script&lang=js&"
export * from "./SalesProgressCard.vue?vue&type=script&lang=js&"
import style0 from "./SalesProgressCard.vue?vue&type=style&index=0&id=506d6d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d6d9c",
  null
  
)

export default component.exports